import React from 'react'
import { useTheme } from '@mui/material'

const styles = theme => ({
  root: {
    height: 18,
    width: 18,
    cursor: 'pointer',
    border: 0,
    background: 'none',
    padding: 0,
  },
  dot: {
    backgroundColor: '#e4e6e7',
    height: 12,
    width: 12,
    borderRadius: 6,
    margin: 3,
  },
  active: {
    backgroundColor: theme.palette.primary.main,
  },
})
type Props = {
  active: boolean
  index: number
  onClick: Function
}

const PaginationDot: React.FC<Props> = ({ active, index, onClick }) => {
  const theme = useTheme()
  const handleClick = event => {
    onClick(event, index)
  }

  let styleDot

  const styleTheme = styles(theme)

  if (active) {
    styleDot = Object.assign({}, styleTheme.dot, styleTheme.active)
  } else {
    styleDot = styleTheme.dot
  }

  return (
    <button type="button" style={styleTheme.root} onClick={handleClick}>
      <div style={styleDot} />
    </button>
  )
}

export default PaginationDot
